import React, {useContext} from 'react'
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import {useRouteMatch} from "react-router-dom";
import {AdminContext} from "v4/contexts/AdminContext";
import CustomActionsForm from "v4/pages/admin/CustomActions/components/CustomActionsForm/CustomActionsForm";
import CustomActionsList from "v4/pages/admin/CustomActions/components/CustomActionsList/CustomActionsList";
export default function CustomActionsPage() {
    const {t} = usePolTranslation();
    const {path, params: {id}, isExact} = useRouteMatch();
    const isAddPage = path.split('/').pop() === 'add';
    const isEditPage = !!id && isExact;
    const isListPage = (!isAddPage && !isEditPage);
    const {asCustomer} = useContext(AdminContext);
    const getComponent = () => {
        if (isListPage) {
            return <CustomActionsList customerId={asCustomer?.id}/>
        }
        return <CustomActionsForm id={id} customerId={asCustomer?.id}/>
    }
    return (
        <>
            {asCustomer?.id ?
                (
                    <>
                        {getComponent()}
                    </>
                ) : (
                    <p>{t('no_customer_defined')}</p>
                )
            }
        </>
    )
}